/* VES on-site all-reviews wall.
   Renders our own brand-native review UI from Judge.me's public JSON feed
   (cdn.judge.me/reviews/all_reviews_js_based) so there is no third-party widget
   markup to fight and pack covers come straight from Shopify's CDN.
   Product reviews come from the public feed. Store (shop) reviews are not served
   on that public feed, so the Store tab links out to Judge.me. Read-only by
   design: writing a review happens on the product page. */
(function () {
  'use strict';

  var BASE = 'https://cdn.judge.me/reviews/all_reviews_js_based';
  var BATCH = 18;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // The feed returns titles/names HTML-escaped (e.g. "Time &amp; Date Pack").
  // Decode entities before rendering so "&amp;", "&#39;" etc. show correctly.
  var DECODER;
  function dec(s) {
    if (s == null) return '';
    if (!DECODER) DECODER = document.createElement('textarea');
    DECODER.innerHTML = String(s);
    return DECODER.value;
  }

  var STAR = 'M12 2l3 7h7l-5.5 4 2 7L12 16l-6.5 4 2-7L2 9h7z';

  function starsSvg(rating, cls) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var on = i <= Math.round(rating);
      out += '<svg viewBox="0 0 24 24" aria-hidden="true" class="ves-rv-star' + (on ? ' is-on' : '') + '"><path d="' + STAR + '"/></svg>';
    }
    return '<span class="' + (cls || 'ves-rv-stars') + '" role="img" aria-label="' + rating + ' out of 5 stars">' + out + '</span>';
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }

  function cleanLocation(loc) { return loc ? loc.replace(/^\(|\)$/g, '').trim() : ''; }

  function initials(name, fallback) {
    if (fallback) return String(fallback).slice(0, 2).toUpperCase();
    var parts = String(name || '').trim().split(/\s+/);
    return ((parts[0] ? parts[0][0] : '') + (parts[1] ? parts[1][0] : '') || '?').toUpperCase();
  }

  function cardEl(r) {
    var name = dec(r.is_anonymous_reviewer ? 'Anonymous' : (r.reviewer_name || 'Anonymous'));
    var loc = dec(cleanLocation(r.location));
    var verified = r.verified_buyer
      ? '<span class="ves-rv-verified" title="Verified buyer"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.2l-3.5-3.5L4 14.2 9 19.2 20 8.2l-1.5-1.5z"/></svg>Verified</span>' : '';
    var avatar = r.avatar_image_url
      ? '<span class="ves-rv-avatar" style="background-image:url(' + esc(r.avatar_image_url) + ')"></span>'
      : '<span class="ves-rv-avatar ves-rv-avatar--initials">' + esc(initials(name, r.reviewer_initial)) + '</span>';

    var cover = r.product_variant_image_url || r.product_pictures_url || '';
    var product = '';
    if (!r.is_shop_review && r.product_title) {
      product = '<a class="ves-rv-card__product" href="' + esc(r.product_url || '#') + '">' +
        (cover ? '<span class="ves-rv-card__cover-wrap"><img class="ves-rv-card__cover" src="' + esc(cover) + '" alt="" loading="lazy"></span>' : '') +
        '<span class="ves-rv-card__product-name"></span></a>';
    }

    var photos = '';
    if (r.pictures_urls && r.pictures_urls.length) {
      photos = '<div class="ves-rv-card__photos">' + r.pictures_urls.slice(0, 4).map(function (u) {
        return '<img src="' + esc(u) + '" alt="" loading="lazy" class="ves-rv-card__photo">';
      }).join('') + '</div>';
    }

    var reply = r.reply_content
      ? '<div class="ves-rv-card__reply"><span class="ves-rv-card__reply-name">' + esc(dec(r.shop_reply_name || 'Video Editor Studio')) + '</span><span class="ves-rv-card__reply-body"></span></div>' : '';

    var el = document.createElement('article');
    el.className = 'ves-rv-card';
    el.innerHTML =
      '<div class="ves-rv-card__head">' + avatar +
        '<div class="ves-rv-card__id">' +
          '<span class="ves-rv-card__name">' + esc(name) + (verified ? ' ' + verified : '') + '</span>' +
          '<span class="ves-rv-card__meta">' + starsSvg(r.rating) +
            '<span class="ves-rv-card__date">' + esc(fmtDate(r.created_at)) + (loc ? ' &middot; ' + esc(loc) : '') + '</span></span>' +
        '</div></div>' +
      (r.title ? '<h3 class="ves-rv-card__title"></h3>' : '') +
      '<p class="ves-rv-card__body"></p>' + photos + reply + product;

    if (r.title) el.querySelector('.ves-rv-card__title').textContent = dec(r.title);
    if (r.product_title) { var pn = el.querySelector('.ves-rv-card__product-name'); if (pn) pn.textContent = dec(r.product_title); }
    if (r.reply_content) el.querySelector('.ves-rv-card__reply-body').textContent = dec(r.reply_content);

    // Body, with an inline "Read more" toggle at the truncation point.
    var body = el.querySelector('.ves-rv-card__body');
    var full = dec(r.body || '');
    var LIMIT = 280;
    if (full.length > LIMIT) {
      var head = full.slice(0, LIMIT).replace(/\s+\S*$/, '').trim();
      var textSpan = document.createElement('span');
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'ves-rv-card__more';
      var open = false;
      var sync = function () {
        textSpan.textContent = open ? full + ' ' : head + '… ';
        more.textContent = open ? 'Show less' : 'Read more';
      };
      more.addEventListener('click', function () { open = !open; sync(); });
      sync();
      body.appendChild(textSpan);
      body.appendChild(more);
    } else {
      body.textContent = full;
    }
    return el;
  }

  function buildUrl(shop, page) {
    return BASE + '?widget_type=all-reviews-widget-v2025&page=' + page +
      '&sort_by=created_at&sort_dir=desc&skip_other_languages=true&widget_theme=cards' +
      '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify';
  }

  function fetchPage(shop, page) {
    return fetch(buildUrl(shop, page)).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status); return r.json();
    });
  }

  function init(root) {
    var shop = root.getAttribute('data-shop-domain');
    if (!shop) return;
    var shopReviewsUrl = root.getAttribute('data-shop-reviews-url') || '#';
    var seedAvg = parseFloat(root.getAttribute('data-avg')) || 0;
    var seedCount = parseInt(root.getAttribute('data-count'), 10) || 0;

    var summary = root.querySelector('[data-rv-summary]');
    var tabsWrap = root.querySelector('[data-rv-tabs]');
    var grid = root.querySelector('[data-rv-grid]');
    var moreBtn = root.querySelector('[data-rv-more]');
    var status = root.querySelector('[data-rv-status]');
    var sortSel = root.querySelector('[data-rv-sort]');
    var searchInput = root.querySelector('[data-rv-search]');

    var product = [], store = [], productTotal = seedCount, storeTotal = 0, allLoaded = false;
    var tab = 'product', rating = 0, q = '', sort = 'recent', shown = 0, view = [];

    // Store (shop) reviews are not on the public feed, so they are seeded
    // server-side from the Judge.me shop metafield.
    var seedEl = root.querySelector('[data-rv-store-seed]');
    if (seedEl) {
      try {
        var seeded = JSON.parse(seedEl.textContent);
        if (Array.isArray(seeded)) {
          store = seeded.map(function (r) { r.is_shop_review = true; return r; });
          storeTotal = store.length;
        }
      } catch (e) { /* keep store empty */ }
    }

    function activeSet() { return tab === 'store' ? store : product; }

    function applySort(list) {
      var a = list.slice();
      if (sort === 'recent') a.sort(function (x, y) { return new Date(y.created_at) - new Date(x.created_at); });
      else if (sort === 'highest') a.sort(function (x, y) { return y.rating - x.rating || new Date(y.created_at) - new Date(x.created_at); });
      else if (sort === 'lowest') a.sort(function (x, y) { return x.rating - y.rating || new Date(y.created_at) - new Date(x.created_at); });
      else if (sort === 'helpful') a.sort(function (x, y) { return (y.thumb_up || 0) - (x.thumb_up || 0); });
      return a;
    }

    function renderGrid() {
      var set = activeSet();
      var f = rating ? set.filter(function (r) { return Math.round(r.rating) === rating; }) : set.slice();
      if (q) {
        var needle = q.toLowerCase();
        f = f.filter(function (r) {
          return ((r.body || '') + ' ' + (r.title || '') + ' ' + (r.reviewer_name || '') + ' ' + (r.product_title || '')).toLowerCase().indexOf(needle) !== -1;
        });
      }
      view = applySort(f); shown = 0; grid.innerHTML = '';
      reveal();
    }

    function reveal() {
      var frag = document.createDocumentFragment();
      var end = Math.min(shown + BATCH, view.length);
      for (var i = shown; i < end; i++) frag.appendChild(cardEl(view[i]));
      grid.appendChild(frag); shown = end;
      moreBtn.hidden = shown >= view.length;
      if (tab === 'store' && !store.length) { renderStoreEmpty(); return; }
      if (!view.length) { status.hidden = false; status.textContent = q ? 'No reviews match your search.' : 'No reviews to show here yet.'; }
      else status.hidden = true;
    }

    function renderStoreEmpty() {
      status.hidden = false;
      status.innerHTML = 'See our ' + (storeTotal || '') + ' store review' + (storeTotal === 1 ? '' : 's') +
        ' on <a href="' + esc(shopReviewsUrl) + '" target="_blank" rel="noopener">Judge.me</a>.';
      moreBtn.hidden = true;
    }

    function renderSummary() {
      var set = activeSet();
      var counts = [0, 0, 0, 0, 0, 0];
      set.forEach(function (r) { counts[Math.round(r.rating)]++; });
      var total = tab === 'store' ? storeTotal : (allLoaded ? product.length : productTotal);
      var avg;
      if (tab === 'product') avg = (allLoaded && product.length) ? (product.reduce(function (s, r) { return s + r.rating; }, 0) / product.length) : seedAvg;
      else avg = set.length ? (set.reduce(function (s, r) { return s + r.rating; }, 0) / set.length) : 0;
      var avgTxt = (Math.round(avg * 10) / 10).toFixed(1);

      var maxC = Math.max(1, counts[5], counts[4], counts[3], counts[2], counts[1]);
      var denom = set.length || 1;
      var rows = '';
      for (var s = 5; s >= 1; s--) {
        var w = Math.round((counts[s] / denom) * 100);
        rows += '<button type="button" class="ves-rv-hist__row' + (rating === s ? ' is-active' : '') + '" data-rv-hist="' + s + '" aria-label="' + counts[s] + ' ' + s + '-star reviews">' +
          starsSvg(s, 'ves-rv-hist__stars') +
          '<span class="ves-rv-hist__track"><span class="ves-rv-hist__fill" style="width:' + w + '%"></span></span>' +
          '<span class="ves-rv-hist__count">' + counts[s] + '</span></button>';
      }

      summary.innerHTML =
        '<div class="ves-rv-summary__score">' +
          '<span class="ves-rv-summary__num">' + avgTxt + '</span>' +
          starsSvg(avg, 'ves-rv-summary__stars') +
          '<span class="ves-rv-summary__count">' + total + ' review' + (total === 1 ? '' : 's') + '</span>' +
          '<a class="ves-rv-summary__badge" href="' + esc(shopReviewsUrl) + '" target="_blank" rel="noopener" title="Reviews verified by Judge.me">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.2l-3.5-3.5L4 14.2 9 19.2 20 8.2l-1.5-1.5z"/></svg>Verified by Judge.me</a>' +
        '</div>' +
        '<div class="ves-rv-summary__hist">' + rows + '</div>';

      [].forEach.call(summary.querySelectorAll('[data-rv-hist]'), function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(b.getAttribute('data-rv-hist'), 10);
          rating = (rating === v) ? 0 : v;
          renderSummary(); renderGrid();
        });
      });
    }

    function renderTabs() {
      tabsWrap.innerHTML =
        '<button type="button" class="ves-rv-tab' + (tab === 'product' ? ' is-active' : '') + '" data-rv-tab="product">Product reviews <span class="ves-rv-tab__n">' + productTotal + '</span></button>' +
        '<button type="button" class="ves-rv-tab' + (tab === 'store' ? ' is-active' : '') + '" data-rv-tab="store">Store reviews <span class="ves-rv-tab__n">' + storeTotal + '</span></button>';
      [].forEach.call(tabsWrap.querySelectorAll('[data-rv-tab]'), function (b) {
        b.addEventListener('click', function () {
          tab = b.getAttribute('data-rv-tab'); rating = 0; q = ''; if (searchInput) searchInput.value = '';
          renderTabs(); renderSummary(); renderGrid();
        });
      });
    }

    moreBtn.addEventListener('click', reveal);
    if (sortSel) sortSel.addEventListener('change', function () { sort = sortSel.value; renderGrid(); });
    if (searchInput) {
      var t;
      searchInput.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { q = searchInput.value.trim(); renderGrid(); }, 180);
      });
    }

    status.hidden = false; status.textContent = 'Loading reviews…'; root.classList.add('is-loading');

    fetchPage(shop, 1).then(function (first) {
      if (!store.length) storeTotal = first.number_of_shop_reviews || 0;
      var pages = (first.pagination && first.pagination.total_pages) || 1;
      var rest = [];
      for (var p = 2; p <= pages; p++) rest.push(fetchPage(shop, p).catch(function () { return null; }));
      return Promise.all(rest).then(function (results) {
        var raw = (first.reviews || []).slice();
        results.forEach(function (j) { if (j && j.reviews) raw = raw.concat(j.reviews); });
        var seen = {}, dedup = [];
        raw.forEach(function (r) { if (r.uuid && seen[r.uuid]) return; if (r.uuid) seen[r.uuid] = 1; dedup.push(r); });
        // Show only reviews whose product is still live on the store.
        product = dedup.filter(function (r) { return r.product_in_store !== false; });
        productTotal = product.length;
        allLoaded = true;
        root.classList.remove('is-loading');
        renderTabs(); renderSummary(); renderGrid();
      });
    }).catch(function () {
      root.classList.remove('is-loading'); root.classList.add('is-error');
      status.hidden = false; status.textContent = 'We could not load reviews right now. Please refresh the page.';
      moreBtn.hidden = true;
    });
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-ves-reviews]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
